// extracted by mini-css-extract-plugin
module.exports = {"how-it-works":"styles_how-it-works__2QGNh","steps":"styles_steps__3u2Zx","step":"styles_step__iqpSn"};